import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(
    private http : HttpClient
  ) { }

    getRegiones(){
      return this.http.get<Region[]>('assets/data/regiones.json');
    }

    getComunas(){
     
      return this.http.get<Comuna[]>('assets/data/comunas.json');
    }

    getDistribuidoras(){
      return this.http.get<Distribuidora[]>('assets/data/distribuidoras.json');
    }
    getSeremias(){
      return this.http.get<Seremia[]>('assets/data/seremias.json');
    }
}
